import { HOST_API_KEY } from "@/globalConfig"
type ApiMethods = "GET" | "POST" | "DELETE" | "PATCH" | "PUT"

var modules = {
  USER_AUTH: "user",
  USER: "users",
  ADDITIONAL_SERVICE: "additional-service",
  TICKET: "ticket",
  SERVICE: "services",
  CLEANER_APP: "cleanerapp",
  AWS: "aws",
  ARRIVAL_DEPARTURE: "arrival-departure",
  FORM: "forms",
  CLEANING_COMPANIES: "cleaningCompanies",
  INTERNAL: "internal",
  OWNERS: "owners",
  MAINTENANCE: "maintenance",
  PDF_GENERATION: "pdf-generation",
  CLEANS: "cleans",
}
export const ROUTES = {
  login: "login",
  getAllPropertyServices: "get_all_property_services",
  getProperty: "get_property",
  getAllProperties: "get_all_properties",
  getMaintainceTicket: "ticket",
  getMaintainceTicketv2: "ticket_v2",
  getMaintananceDashboardCount: "maintanance_dashboard_count",
  getMaintananceDashboardCountv2: "maintanance_dashboard_count_v2",
  updateStatus: "update_status",
  checkInOut: "check-in-out",
  getAllComments: "comments",
  postComments: "comments",
  getUserDetails: "userDetails",
  getAccounts: "account",
  updateAccount: "account",
  postSecurity: "security",
  cleansCount: "cleans_count",
  cleansCountv2: "cleans_count_v2",
  cleanDetails: "clean",
  getCleanTickets: "get_cleans",
  getCleanTicketsv2: "get_cleans_v2",
  getMaintanceGuestDetails: "ticket_details",
  getTicketGuestDetails: "ticket_guest_details",
  // updateCleanTablePriority: "cleans-priority-number", // Deprecated
  updateCleanTable: "cleans-update-table",
  uploadImages: "image-aws",
  addNote: "note",
  editClean: "edit-clean",
  deleteNote: "notes",
  propertyCleanCompany: "property-clean-company",
  cleaningCompanyManager: "cleaning_companies_manager",
  reservationId: "propertyReservations",
  addClean: "add_clean",
  getPurchaseTickets: "tickets",
  getPurchaseTicketsv2: "tickets_v2",
  getPurchaseModal: "modal",
  getPurchaseTicketAssignForm: "ticket-asssign-form",
  getPurchaseInternalEmployees: "internal-employees",
  postPurchaseTicketAssign: "form-submission",
  getaArrivalDepartureCount: "ticket-count",
  getaArrivalDepartureCountv2: "and_ticket_count_v2",
  getGuestRequestCountv2: "guest_ticket_count_v2",
  getPostArrivalDepartureTicket: "arrival-departure/ticket",
  getPostArrivalDepartureTicketv2: "arrival-departure/ticket_v2",
  getArrivalDepartureInnerDetail: "arrival-departure-inner",
  getArrivalDepartureTicketAssignForm: "ticket-assign-form",
  postArrivalDepartureTicketFormAssign: "ticket-form-submission",
  postGetFormByKeyId: "getFromById",
  getArrivalDepartureFormValueTicketDetails: "arrival-depature-ticketDetails",
  postArrivalDepartureFormSubmission: "arrival-depature-form-submission",
  postUpdateMaintenance: "maintenance/update_ticket",
  getCompanyList: "company_list",
  getCompanyUserList: "company_user_list",
  getBedConfig: "bedroom-configuration",
  getBedType: "bed_types",
  getServices: "services",
  getServiceTypes: "list",
  putBedRoomConfig: "bedroom-configuration",
  postMaintainceTicketAssign: "ticket_assign",
  getOragnizations: "organizations",
  postNewUser: "add_users",
  getUsers: "get_users",
  getExternalComapanies: "company-list",
  getContractorUser: "contractor-users",
  postAddEditCompany: "company/new",
  postEditCompany: "company/edit",
  postAddCompany: "company",
  getChildrenEquipmentProducts: "children_equipment_products",
  postEditChildrenEquipProducts: "edit_children_equip_products",
  postProductStatus: "product-status",
  postTicketReview: "update",
  postCleanReview: "clean-review-status/update",
  getContractorCompanies: "external-company-list",
  postContractorDetailUpdate: "contractor-user/update",
  updateMainenanceRequest: "update_ticket_status",
  updateMaintenanceDueDate: "update_due_date",
  getContractorCompanyDetails: "contractor-company",
  postContractorCompanies: "company/new",
  postAddContractorUser: "contractor-user",
  putEditUser: "edit_user",
  getPropertyReservation: "get_propertyReservations",
  getNextReservation: "get_next_reservation",
  postArrivalDepartureTicketAssign: "ticket-assign",
  updateAssignPurchase: "assign_to",
  postGSVerify: "gsverify",
  readTicket: "mark_read",
  getBookingNotes: "notes/booking-notes",
  getEmployeesv2: "/v2/employees",
  updateNotRequired: "/update/not-required-status",
  getAvailCalendar: "/availability-calendar",
  getOwnersProperty: "Get List of Properties with Code and Name",
  getOwnersList: "list-owners",
  getOwnerByID: "owner",
  deleteOwner: "delete-owner",
  updateOwnerActiveStatus: "activate-deactivate-owner",
  createOwner: "create_owner",
  updateOwner: "update_owner",
  linkPropertiesWithOwner: "link_properties_with_owner",
  unlinkPropertiesWithOwner: "unlink_properties_with_owner",
  getArrivalDepartureForm: "get-arrival-form",
  createMaintenanceTicket: "/maintenance/create-ticket",
  maintenanaceTicketRequest: "/maintenance-request/ticket-details",
  getPropertyReservationTimeline: "/get_propert-reservations/",
  postMaintenanceFormSubmission: "maintenance-form-submission",
  getPdfForMaintenanceForm: "getPdfForMaintenanceForm",
  getPdfForArrivalDepartureForm: "getPdfForArrivalDepartureForm",
  getPdfForCleansForm: "getPdfForCleansForm",
  getCleaningCompanies: "CLEANER_APP",
  createCleansTicket: `/create-ticket`,
  cleansTicketRequest: "/cleans/ticket-details",
  postCleansFormSubmission: "cleans-form-submission",
  updateMaintenanceTicket: "maintenance/update-ticket",
  getCompanyListv2: "company-list",
}
export const API_END_POINT: Record<ApiMethods, Record<string, string>> = {
  GET: {
    [ROUTES.getAllPropertyServices]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/get_all_property_services`,
    [ROUTES.getProperty]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/get_property`,
    [ROUTES.getAllProperties]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/get_all_property`,
    [ROUTES.checkInOut]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/check-in-out`,
    [ROUTES.getChildrenEquipmentProducts]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/children_equipment_products`,
    [ROUTES.getAllComments]: `${HOST_API_KEY}${modules.TICKET}/comments`,
    [ROUTES.getUserDetails]: `${HOST_API_KEY}${modules.USER}/userDetails`,
    [ROUTES.getAccounts]: `${HOST_API_KEY}${modules.USER}/account`,
    [ROUTES.cleansCount]: `${HOST_API_KEY}${modules.CLEANER_APP}/cleans_count`,
    [ROUTES.cleanDetails]: `${HOST_API_KEY}${modules.CLEANER_APP}/clean`,
    [ROUTES.getMaintanceGuestDetails]: `${HOST_API_KEY}${modules.TICKET}/ticketDetails`,
    [ROUTES.getTicketGuestDetails]: `${HOST_API_KEY}${modules.TICKET}/ticket_guest_details`,
    [ROUTES.propertyCleanCompany]: `${HOST_API_KEY}${modules.CLEANER_APP}/property-clean-company`,
    [ROUTES.cleaningCompanyManager]: `${HOST_API_KEY}${modules.CLEANER_APP}/cleaning_companies_manager`,
    [ROUTES.reservationId]: `${HOST_API_KEY}${modules.CLEANER_APP}/propertyReservations`,
    [ROUTES.getPurchaseModal]: `${HOST_API_KEY}${modules.TICKET}/additional-services/modal`,
    [ROUTES.getPurchaseTicketAssignForm]: `${HOST_API_KEY}${modules.TICKET}/additional-services/ticket-asssign-form`,
    [ROUTES.getPurchaseInternalEmployees]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/internal-employees`,
    [ROUTES.getaArrivalDepartureCount]: `${HOST_API_KEY}${modules.TICKET}/${modules.ARRIVAL_DEPARTURE}/ticket-count`,
    [ROUTES.getArrivalDepartureInnerDetail]: `${HOST_API_KEY}${modules.TICKET}/arrival-departure-inner`,
    [ROUTES.getArrivalDepartureTicketAssignForm]: `${HOST_API_KEY}${modules.TICKET}/arrival-departure-inner/ticket-assign-form`,
    [ROUTES.getArrivalDepartureFormValueTicketDetails]: `${HOST_API_KEY}${modules.TICKET}/arrival-depature-ticketDetails`,
    [ROUTES.getBedConfig]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/bedroom-configuration`,
    [ROUTES.getBedType]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/bed-types`,
    [ROUTES.getServices]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/services`,
    [ROUTES.getServiceTypes]: `${HOST_API_KEY}${modules.CLEANING_COMPANIES}/list/service`,
    [ROUTES.getCompanyList]: `${HOST_API_KEY}${modules.TICKET}/company_list`,
    [ROUTES.getCompanyUserList]: `${HOST_API_KEY}${modules.TICKET}/company_user_list`,
    [ROUTES.getOragnizations]: `${HOST_API_KEY}${modules.USER}/organizations`,
    [ROUTES.getUsers]: `${HOST_API_KEY}${modules.USER}/get_users`,
    [ROUTES.getExternalComapanies]: `${HOST_API_KEY}${modules.CLEANING_COMPANIES}/company-list`,
    [ROUTES.getContractorUser]: `${HOST_API_KEY}${modules.USER}/contractor-users`,
    [ROUTES.getMaintananceDashboardCount]: `${HOST_API_KEY}${modules.TICKET}/maintanance_dashboard_count`,
    [ROUTES.getContractorCompanies]: `${HOST_API_KEY}${modules.CLEANING_COMPANIES}/external-company-list`,
    [ROUTES.getContractorCompanyDetails]: `${HOST_API_KEY}${modules.USER}/contractor-company`,
    [ROUTES.getPropertyReservation]: `${HOST_API_KEY}${modules.CLEANER_APP}/get_propertyReservations`,
    [ROUTES.getNextReservation]: `${HOST_API_KEY}${modules.CLEANER_APP}/get_next_reservation`,
    [ROUTES.getOwnerByID]: `${HOST_API_KEY}${modules.OWNERS}/owner/`,
    [ROUTES.getArrivalDepartureForm]: `${HOST_API_KEY}${modules.TICKET}/arrival-depature-ticketDetails`,
    [ROUTES.maintenanaceTicketRequest]: `${HOST_API_KEY}${modules.TICKET}/maintenance/ticket_details`,
    [ROUTES.getPropertyReservationTimeline]: `${HOST_API_KEY}${modules.MAINTENANCE}/get_property_reservations`,
    [ROUTES.getPdfForMaintenanceForm]: `${HOST_API_KEY}${modules.PDF_GENERATION}/maintenance/ticket_details_pdf`,
    [ROUTES.getPdfForArrivalDepartureForm]: `${HOST_API_KEY}${modules.PDF_GENERATION}/arrival-depature-ticketDetails_pdf`,
    [ROUTES.getCleaningCompanies]: `${HOST_API_KEY}${modules.CLEANER_APP}/property-clean-company`,
    [ROUTES.cleansTicketRequest]: `${HOST_API_KEY}${modules.CLEANS}/ticket_details`,
    [ROUTES.getPdfForCleansForm]: `${HOST_API_KEY}${modules.PDF_GENERATION}/cleans_ticket_details_pdf`,
  },
  POST: {
    [ROUTES.login]: `${HOST_API_KEY}${modules?.USER_AUTH}/login`,
    [ROUTES.updateStatus]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/${modules.SERVICE}/update_status`,
    [ROUTES.postEditChildrenEquipProducts]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/edit_children_equip_products`,
    [ROUTES.postProductStatus]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/product-status`,
    [ROUTES.postComments]: `${HOST_API_KEY}${modules.TICKET}/comments`,
    [ROUTES.uploadImages]: `${HOST_API_KEY}${modules.AWS}/image-aws`,
    [ROUTES.addNote]: `${HOST_API_KEY}${modules.CLEANER_APP}/add_note`,
    [ROUTES.getCleanTickets]: `${HOST_API_KEY}${modules.CLEANER_APP}/get_cleans`,
    [ROUTES.editClean]: `${HOST_API_KEY}${modules.CLEANER_APP}/edit_clean`,
    [ROUTES.deleteNote]: `${HOST_API_KEY}${modules.CLEANER_APP}/notes/delete`,
    [ROUTES.addClean]: `${HOST_API_KEY}${modules.CLEANER_APP}/add_clean`,
    [ROUTES.postPurchaseTicketAssign]: `${HOST_API_KEY}${modules.TICKET}/additional-services/ticket-assign/form-submission`,
    [ROUTES.postArrivalDepartureTicketFormAssign]: `${HOST_API_KEY}${modules.TICKET}/arrival-departure-inner/ticket-form-submission`,
    [ROUTES.postGetFormByKeyId]: `${HOST_API_KEY}${modules.FORM}/getFromById`,
    [ROUTES.postArrivalDepartureFormSubmission]: `${HOST_API_KEY}${modules.FORM}/arrival-depature-form-submission`,
    [ROUTES.postMaintainceTicketAssign]: `${HOST_API_KEY}${modules.TICKET}/ticket_assign`,
    [ROUTES.postSecurity]: `${HOST_API_KEY}${modules.USER}/security`,
    [ROUTES.postNewUser]: `${HOST_API_KEY}${modules.USER}/add_user`,
    [ROUTES.postTicketReview]: `${HOST_API_KEY}${modules.TICKET}/ticket-review-status/update`,
    [ROUTES.postUpdateMaintenance]: `${HOST_API_KEY}${modules.TICKET}/maintenance/update_ticket`,
    [ROUTES.postCleanReview]: `${HOST_API_KEY}cleans/clean-review-status/update`,
    [ROUTES.postContractorDetailUpdate]: `${HOST_API_KEY}${modules?.USER}/contractor-user/update`,
    [ROUTES.updateMainenanceRequest]: `${HOST_API_KEY}${modules.TICKET}/maintenance/update_ticket_status`,
    [ROUTES.updateMaintenanceDueDate]: `${HOST_API_KEY}${modules.TICKET}/maintenance/update_due_date`,
    [ROUTES.postAddEditCompany]: `${HOST_API_KEY}${modules.CLEANING_COMPANIES}/company/new`,
    [ROUTES.postAddContractorUser]: `${HOST_API_KEY}${modules.USER}/contractor-user`,
    [ROUTES.postEditCompany]: `${HOST_API_KEY}${modules.CLEANING_COMPANIES}/company/edit`,
    [ROUTES.postArrivalDepartureTicketAssign]: `${HOST_API_KEY}${modules.TICKET}/${modules.ARRIVAL_DEPARTURE}/ticket-assign`,
    [ROUTES.getPostArrivalDepartureTicket]: `${HOST_API_KEY}${modules.TICKET}/arrival-departure/ticket`,
    [ROUTES.getMaintainceTicket]: `${HOST_API_KEY}${modules.TICKET}/ticket`,
    [ROUTES.readTicket]: `${HOST_API_KEY}${modules.TICKET}/${ROUTES.readTicket}`,
    [ROUTES.getPurchaseTickets]: `${HOST_API_KEY}${modules.TICKET}/additional-services/tickets`,
    [ROUTES.getBookingNotes]: `${HOST_API_KEY}${ROUTES.getBookingNotes}`,
    [ROUTES.cleansCountv2]: `${HOST_API_KEY}${modules.CLEANER_APP}/cleans_count_v2`,
    [ROUTES.getCleanTicketsv2]: `${HOST_API_KEY}${modules.CLEANER_APP}/get_cleans_v2`,
    [ROUTES.getaArrivalDepartureCountv2]: `${HOST_API_KEY}${modules.TICKET}/${modules.ARRIVAL_DEPARTURE}/ticket_count_v2`,
    [ROUTES.getPostArrivalDepartureTicketv2]: `${HOST_API_KEY}${modules.TICKET}/arrival-departure/ticket_v2`,
    [ROUTES.getMaintananceDashboardCountv2]: `${HOST_API_KEY}${modules.TICKET}/maintanance_dashboard_count_v2`,
    [ROUTES.getMaintainceTicketv2]: `${HOST_API_KEY}${modules.TICKET}/ticket_v2`,
    [ROUTES.getGuestRequestCountv2]: `${HOST_API_KEY}${modules.TICKET}/additional-services/ticket_count_v2`,
    [ROUTES.getPurchaseTicketsv2]: `${HOST_API_KEY}${modules.TICKET}/additional-services/tickets_v2`,
    [ROUTES.getEmployeesv2]: `${HOST_API_KEY}${modules.USER}/v2/employees`,
    [ROUTES.updateNotRequired]: `${HOST_API_KEY}${modules.INTERNAL}/update/not-required-status`,
    [ROUTES.getAvailCalendar]: `${HOST_API_KEY}property_reservationDetails/availability-calendar`,
    [ROUTES.getOwnersProperty]: `${HOST_API_KEY}${modules.OWNERS}/list-owner-properties`,
    [ROUTES.getOwnersList]: `${HOST_API_KEY}${modules.OWNERS}/list-owners`,
    [ROUTES.deleteOwner]: `${HOST_API_KEY}${modules.OWNERS}/delete-owner`,
    [ROUTES.updateOwnerActiveStatus]: `${HOST_API_KEY}${modules.OWNERS}/activate-deactivate-owner`,
    [ROUTES.createOwner]: `${HOST_API_KEY}${modules.OWNERS}/add_owner`,
    [ROUTES.updateOwner]: `${HOST_API_KEY}${modules.OWNERS}/edit-owner`,
    [ROUTES.linkPropertiesWithOwner]: `${HOST_API_KEY}${modules.OWNERS}/link-owner-properties`,
    [ROUTES.unlinkPropertiesWithOwner]: `${HOST_API_KEY}${modules.OWNERS}/unlink-owner-property`,
    [ROUTES.createMaintenanceTicket]: `${HOST_API_KEY}${modules.TICKET}/maintenance/create_ticket`,
    [ROUTES.postMaintenanceFormSubmission]: `${HOST_API_KEY}${modules.FORM}/maintenance-form-submission`,
    [ROUTES.createCleansTicket]: `${HOST_API_KEY}${modules.CLEANS}/create_ticket`,
    [ROUTES.postCleansFormSubmission]: `${HOST_API_KEY}${modules.CLEANS}/cleans-form-submission`,
    [ROUTES.updateMaintenanceTicket]: `${HOST_API_KEY}${modules.MAINTENANCE}/update-ticket`,
    [ROUTES.getCompanyListv2]: `${HOST_API_KEY}${modules.CLEANING_COMPANIES}/v2/company-list`,
  },
  PATCH: {
    [ROUTES.checkInOut]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/check-in-out`,
    // [ROUTES.updateCleanTablePriority]: `${HOST_API_KEY}${modules.CLEANER_APP}/cleans-priority-number`, // Deprecated
    [ROUTES.updateCleanTable]: `${HOST_API_KEY}${modules.CLEANER_APP}/cleans-update-table`,
    [ROUTES.updateAccount]: `${HOST_API_KEY}${modules.USER}/account`,
    [ROUTES.updateAssignPurchase]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/assign_to`,
    [ROUTES.postGSVerify]: `${HOST_API_KEY}${modules.CLEANER_APP}/gsverify`,
  },
  DELETE: {},
  PUT: {
    [ROUTES.putBedRoomConfig]: `${HOST_API_KEY}${modules.ADDITIONAL_SERVICE}/bedroom-configuration`,
    [ROUTES.putEditUser]: `${HOST_API_KEY}${modules.USER}/edit_user`,
  },
}
export default API_END_POINT
